// extracted by mini-css-extract-plugin
export default {"unionLine":"UnionEdge_unionLine__tPrfl","hoverPath":"UnionEdge_hoverPath__l1kCq"};